<template>
  <div>
    <v-row no-gutters v-if="!loading && items">
      <v-col :key="item.id" cols="12" v-for="item in items">
        <ItemCardHorizontal :value="item" @add="$emit('add', item)"/>
      </v-col>
    </v-row>
    <v-row dense v-if="loading || fetching">
      <v-col :key="i" cols="12" v-for="i in 2">
        <ItemCardLoading/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
	import ItemCardLoading from "../templates/elements/ItemCardLoading";
	import list from "../../mixins/items/list";
	import ItemCardHorizontal from "../templates/elements/ItemCardHorizontal";

	export default {
		name: 'ProductListHorizontalCards',
		components: { ItemCardHorizontal, ItemCardLoading },
		mixins: [list]
	}
</script>

<style lang="scss" scoped>
  ::v-deep {
    .v-skeleton-loader__list-item-three-line.v-skeleton-loader__bone {
      background: none;
    }
  }
</style>
